module.exports = __webpack_public_path__ + "static/chaspy_-ab9abf48a05726e516c4ff66042947ab.jpg";